module.exports = __webpack_public_path__ + "img/usuario.aa25e1e2.png";